// import { QuillEditor as Wysiwyg } from "@vueup/vue-quill";
import { DraggablePlugin } from "@braks/revue-draggable";

export default defineNuxtPlugin((nuxtApp) => {
  // nuxtApp.vueApp.component("Wysiwyg", Wysiwyg);
  nuxtApp.vueApp.use(DraggablePlugin);
});
